import { inView } from 'global/inview.src';
import formAttachValidation from './form';

$(document).ready(() => {
    // Animation
    /* ------------------------------------*\
     ANIMATE
     \*------------------------------------*/
    inView({
        elems: document.querySelectorAll('.in-view'),
        onVisible(elem) {
            elem.classList.add('visible');
        },
        tolerance: 0.25,
    });

    if (document.querySelector('.signup form')) {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting === true) {
                formAttachValidation();
                observer.unobserve(document.querySelector('.signup form'));
            }
        }, {});
        observer.observe(document.querySelector('.signup form'));
    }
});

$(() => {
    $('input.form-control').blur(function () {
        const tmpval = $(this).val();
        if (tmpval == '') {
            $(this).addClass('empty');
            $(this).removeClass('not-empty');
        } else {
            $(this).addClass('not-empty');
            $(this).removeClass('empty');
        }
    });
    $('input.form-control').trigger('blur');

    // Show THX section
    if (window.location.hash === '#thank-you') {
        $('body').addClass('thank-you');
        window.scrollTo(0, 0);
    }
});
